import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import ArgonBox from 'components/ArgonBox';
import { item, itemIcon, itemText, itemIconBox } from 'examples/Sidenav/styles/sidenavItem';
import { useArgonController } from 'context';

function SidenavItem({ icon, name, active, open, nested, ...rest }) {
  const [controller] = useArgonController();
  const { miniSidenav, darkSidenav, sidenavColor } = controller;

  return (
    <>
      <ListItem component="li">
        <ArgonBox {...rest} sx={(theme) => item(theme, { active, darkSidenav, sidenavColor, miniSidenav, nested })}>
          <ListItemIcon sx={(theme) => itemIconBox(theme, { active, darkSidenav, sidenavColor })}>
            {typeof icon === 'string' ? <Icon sx={(theme) => itemIcon(theme, { active })}>{icon}</Icon> : icon}
          </ListItemIcon>
          <ListItemText primary={name} sx={(theme) => itemText(theme, { miniSidenav, darkSidenav, active, nested })} />
        </ArgonBox>
      </ListItem>
    </>
  );
}

SidenavItem.defaultProps = {
  color: 'info',
  active: false,
  open: false,
  nested: false,
};

SidenavItem.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'error', 'dark']),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  open: PropTypes.bool,
  nested: PropTypes.bool,
};

export default SidenavItem;
